import apiClient from "utils/apiClient";
import { O_CLIENT_APP, OLIVEEB_APP_VALUES } from "constants";

const guestSessionStorageKey = "olreadiaGuestSession";
const guestDeviceStorageKey = "olreadiaGuestDeviceId";
const normalizedClientApp = String(O_CLIENT_APP || "").trim().toLowerCase().replace(/_/g, "-");
const olreadiaGuestApp = OLIVEEB_APP_VALUES.includes(normalizedClientApp)
  ? normalizedClientApp
  : O_CLIENT_APP;

const getGuestDeviceId = () => {
  try {
    const existing = window.localStorage.getItem(guestDeviceStorageKey);
    if (existing) return existing;
    const generated =
      window.crypto && typeof window.crypto.randomUUID === "function"
        ? window.crypto.randomUUID()
        : `olreadia-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(guestDeviceStorageKey, generated);
    return generated;
  } catch {
    return `olreadia-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
};

const getStoredGuestSession = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(guestSessionStorageKey) || "null");
    if (!stored?.accessToken) return null;
    if (stored.expiresAt && new Date(stored.expiresAt).getTime() <= Date.now() + 30000) {
      return null;
    }
    return stored;
  } catch {
    return null;
  }
};

const saveGuestSession = (session) => {
  try {
    window.localStorage.setItem(guestSessionStorageKey, JSON.stringify(session));
  } catch {
    // The token can still be used for this in-memory request.
  }
};

export const bearerGuestToken = (session) => {
  const token = session?.accessToken;
  if (!token) return "";
  return token.startsWith("Bearer ") ? token : `Bearer ${token}`;
};

export const ensureGuestSession = async ({ refresh = false } = {}) => {
  const stored = refresh ? null : getStoredGuestSession();
  if (stored) return stored;

  const response = await apiClient.post(
    "/identity-service/api/v1/auth/guest-session",
    {
      deviceId: getGuestDeviceId(),
      platform: "web",
      appVersion: process.env.REACT_APP_VERSION || "web",
      app: olreadiaGuestApp,
    },
    {
      skipAuthContext: true,
      headers: {
        "O-SKIP-WORKSPACE-CONTEXT": "1",
      },
    },
  );
  saveGuestSession(response.data);
  return response.data;
};
